import { useEffect, useState } from "react";
import type { GameTask } from "../../domain/types";
import { useGameStore } from "../../stores/gameStore";
import {
  confirmSettlement,
  prepareSettlement,
  type PreparedSettlement,
} from "./service";

const methodLabel: Record<string, string> = {
  carve_body: "本体剥取",
  carve_tail: "断尾剥取",
  capture: "捕获报酬",
  target_reward: "目标报酬",
  break_part: "部位破坏",
  shiny_drop: "掉落物",
};

export function CarvingSettlementModal({ task }: { task: GameTask }) {
  const { archive, setArchive } = useGameStore();
  const [prepared, setPrepared] = useState<PreparedSettlement | null>(null);
  const [revealed, setRevealed] = useState(0);
  const [committing, setCommitting] = useState(false);
  useEffect(() => {
    if (archive) {
      setPrepared(prepareSettlement(archive, task));
      setRevealed(0);
    }
  }, [archive?.name, task.id]);
  if (!archive || !prepared) return null;
  const done = revealed >= prepared.rolls.length;
  return <div className="modal-backdrop"><section className="modal carving-modal" role="dialog" aria-modal="true" aria-label="任务剥取结算">
    <span className="eyebrow">任务结算</span><h2>{task.title}</h2>
    <p>{prepared.rolls.length ? "公会已锁定本次确定性结算。依次揭示，不会因刷新改变结果。" : "该任务没有怪物剥取，直接领取公会报酬。"}</p>
    <div className="carves">{prepared.rolls.map((roll, index) => <div className={index < revealed ? "carve revealed" : "carve"} key={`${roll.method}:${index}`}>{index < revealed ? <><small>{methodLabel[roll.method] ?? roll.method}</small><b>{roll.entry.name} ×{roll.entry.quantity}</b><span>{"★".repeat(Math.max(1, Math.min(10, roll.entry.rarity)))}</span></> : <><small>{methodLabel[roll.method] ?? roll.method}</small><b>?</b></>}</div>)}</div>
    {!done ? <button className="primary" onClick={() => setRevealed((count) => count + 1)}>剥取 / 揭示下一项</button> : <><div className="reward-line"><b>{task.reward.zenny} z</b><span>HR +{task.reward.hrExp}</span><span>GP +{task.reward.guildPoints}</span></div><button className="primary" disabled={committing} onClick={async () => { if (committing || task.settlementDone) return; setCommitting(true); try { await setArchive(confirmSettlement(archive, prepared)); } finally { setCommitting(false); } }}>{committing ? "结算入库中……" : "确认结算并返回据点"}</button></>}
  </section></div>;
}
